import * as React from 'react';
export default class Drag extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="1.45448" cy="1.45448" r="1.45448" fill="#7AB5E3"/>
        <circle cx="1.45448" cy="5.81873" r="1.45448" fill="#7AB5E3"/>
        <circle cx="1.45448" cy="10.182" r="1.45448" fill="#7AB5E3"/>
        <circle cx="1.45448" cy="14.5453" r="1.45448" fill="#7AB5E3"/>
        <circle cx="7.27235" cy="1.45448" r="1.45448" fill="#7AB5E3"/>
        <circle cx="7.27235" cy="5.81873" r="1.45448" fill="#7AB5E3"/>
        <circle cx="7.27235" cy="10.182" r="1.45448" fill="#7AB5E3"/>
        <circle cx="7.27235" cy="14.5453" r="1.45448" fill="#7AB5E3"/>
        </svg>
    )
  }
}